import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, take } from 'rxjs';
import { UIModule } from '@bannerflow/ui';

import { LoginService } from '../../services';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [AsyncPipe, UIModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class LoginComponent implements OnInit {
    private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
    private loginService: LoginService = inject(LoginService);
    private auth: AuthService = inject(AuthService);

    public isAuthenticated$: Observable<boolean> = this.auth.isAuthenticated$;

    ngOnInit(): void {
        this.auth.isAuthenticated$.pipe(take(1)).subscribe(isAuthenticated => {
            if (!isAuthenticated) {
                const connectionHint: string = this.activatedRoute.snapshot.queryParams.ch ?? '';
                this.loginService.loginWithConnectionHint(connectionHint);
            }
        });
    }
}
